import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ptBR, enUS, es } from 'date-fns/locale';
import {
  ptBR as pt_br,
  enUS as en_us,
  esES as es_es,
} from '@mui/x-date-pickers/locales';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface DateBasePickerInterface {
  children: JSX.Element;
}

export const DateBasePicker = ({ children }: DateBasePickerInterface) => {
  const localeMap: { [key: string]: Locale } = {
    en: enUS,
    es: es,
    'pt-BR': ptBR,
    pt: ptBR,
  };
  const localMapLocales: { [key: string]: any } = {
    en: en_us,
    es: es_es,
    'pt-BR': pt_br,
    pt: pt_br,
  };
  const { i18n } = useTranslation('signInPersonalInfo');
  const [locale, setLocale] = useState(localeMap[i18n.language] || enUS);
  const [locales, setLocales] = useState(
    localMapLocales[i18n.language] || en_us
  );

  useEffect(() => {
    setLocale(localeMap[i18n.language] || enUS);
    setLocales(localMapLocales[i18n.language] || en_us);
  }, [i18n.language]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={locale}
      localeText={
        locales.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      {children}
    </LocalizationProvider>
  );
};
